const AppConfigMixin = {
  computed: {
    appMainConfig() {
      return this.$store.getters.main_config_data;
    },
    appComponentData() {
      return this.appMainConfig?.content
        ? this.appMainConfig?.content
        : new Object();
    },
    isAppMainConfigReady() {
      return this.$store.getters.main_config_data ? true : false;
    },
    appMainConfigFailure() {
      return this.$store.getters.main_config_failure;
    },
    newVersionAvailable() {
      return this.$store.getters.app_new_version_info
        ? this.$store.getters.app_new_version_info
        : null;
    },
  },
  methods: {
    getMainAppConfig() {
      return this.$store.dispatch("get_app_config_data", this.$route);
    },
  },
};

export default AppConfigMixin;
